import CityPageTemplate from "../city-template/CityPageTemplate";
import { burbankConfig } from "./data";

export default function BurbankPage() {
  return <CityPageTemplate config={burbankConfig} />;
}